<script lang="ts">
  import Icon from "../Icon.svelte";

  export let klass: string = "";
  export let sortable: boolean = false;
</script>

<th class={klass}>
  {#if sortable}
    <Icon name="sort" />
  {/if}

  <slot />
</th>
